// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__02nrM","value":"styles_value__nV+UP","title":"styles_title__B-Aza","opacity":"styles_opacity__RcssA"};